import React, { useEffect, useState } from "react";
import StatsCard from "../components/dashboard/StatsCard";
import DashboardHeader from "../components/dashboard/DashboardHeader";
import ActivityChart from "../components/common/ActivityChart";
import OverviewChart from "../components/dashboard/OverviewChart";
import { toggleSidebar } from "../utils/sidebarToggle";
import {
  getDashboardOverview,
  getDashboardStats,
} from "../services/dashboardService";
import { limitNumber } from "../utils/number";
import { Loader } from "../components/common/Loader";

export default function Dashboard() {
  const [stats, setStats] = useState({
    cards: [
      { title: "Total Recievable", value: 0, percent: 0 },
      { title: "Total Payable", value: 0, percent: 0 },
      { title: "Total Sale", value: 0, percent: 0 },
      { title: "Total Customer", value: 0, percent: 0 },
      { title: "Pending Rate Work", value: 0, percent: 0 },
      { title: "Weekly Rate Work", value: 0, percent: 0 },
      { title: "Post Date Rate Work", value: 0, percent: 0 },
    ],

    activityData: {
      labels: [
        "Recievable",
        "Payable",
        "Sale",
        "Customer",
        "Pending",
        "Weekly",
        "Post Date",
      ],
      values: [90, 0, 0, 0, 0, 0, 0],
      colors: [
        "#b57f00",
        "#2b2b2b",
        "#6d6d6d",
        "#ff7f50",
        "#20b2aa",
        "#8a2be2",
        "#ff6347",
      ],
    },
  });

  const [loadingStats, setLoadingStats] = useState(false);

  const [overview, setOverview] = useState({});
  const [loadingOverview, setLoadingOVerview] = useState(false);

  useEffect(() => {
    getStats();
    getOverview();
  }, []);

  const getStats = async () => {
    setLoadingStats(true);
    try {
      const response = await getDashboardStats();

      if (response) {
        setStats(response);
      }
    } catch (err) {
    } finally {
      setLoadingStats(false);
    }
  };

  const getOverview = async () => {
    setLoadingOVerview(true);
    try {
      const response = await getDashboardOverview();

      if (response) {
        setOverview(response);
      }
    } catch (err) {
    } finally {
      setLoadingOVerview(false);
    }
  };

  // const cards = [];
  // const activityData = {
  //   labels: [
  //     "Recievable",
  //     "Payable",
  //     "Sale",
  //     "Customer",
  //     "Pending",
  //     "Weekly",
  //     "Post Date",
  //   ],
  //   values: [90, 0, 0, 0, 0, 0, 0],
  //   colors: [
  //     "#b57f00",
  //     "#2b2b2b",
  //     "#6d6d6d",
  //     "#ff7f50",
  //     "#20b2aa",
  //     "#8a2be2",
  //     "#ff6347",
  //   ],
  // };

  // console.log({ stats });
  return (
    <>
      <DashboardHeader toggleSidebar={toggleSidebar} />

      <div className="container" id="dashboardRoot">
        <div className="row mt-5">
          {/* Cards + Activity */}
          {loadingStats ? (
            <Loader height="300px" />
          ) : (
            <>
              <div className="col-12 col-md-8">
                <div className="row">
                  {stats.cards?.map((card, index) => (
                    <StatsCard
                      key={index}
                      title={card.title}
                      value={limitNumber(card.value)}
                      percent={card.percent}
                      link={card.filter}
                    />
                  ))}
                </div>
              </div>

              {/* Activity Chart */}
              <div className="col-12 col-md-4">
                <div className="activityContent shadow p-2 mt-3">
                  <div className="fs-2 ms-3 mt-1 my-5">Activity</div>
                  <ActivityChart data={stats?.activityData} />
                </div>
              </div>
            </>
          )}

          {/* Overview */}
          <div className="col-12 mt-3 my-5">
            <div className="shadow overviewChart p-3">
              <div className="fs-4 mb-3">Overview</div>

              {loadingOverview ? (
                <Loader height="250px" />
              ) : (
                <OverviewChart
                  labels={overview?.labels}
                  values={overview?.values}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
